import type { ReactNode } from 'react';

import { isInternalLandingHref, isSafeLandingFooterHref } from '../../_lib/landing-footer-links';

export function LandingFooterLink({ href, disabled, children }: {
  href: string;
  disabled?: boolean;
  children: ReactNode;
}) {
  if (!isSafeLandingFooterHref(href)) return null;
  if (disabled) return <span>{children}</span>;

  return isInternalLandingHref(href)
    ? <a href={href}>{children}</a>
    : <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
}
